import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { LayoutWithStepper } from 'layouts';
import { connect } from 'react-redux';
import { stepAction, idPassportAction, applicantAction } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import {
  PaddedContainer, FooterAction, UploadButton, FormElementContainer,
  Label, ActionModal, Modal, Button, PageContentWrapper,
  CheckMark,
} from 'components';
import { PATH, FORM_KEYS, APPLICANT_HISTORY_CODE } from 'shared/constant';
import Resizer from 'react-image-file-resizer';
// import { Link } from 'react-router-dom';

// import FileInputComponent from 'react-file-input-previews-base64';

import './Scanning.scss';
import { isMobileOnly } from 'react-device-detect';

class Scanning extends Component {
  constructor(props) {
    super(props);
    this.fileChangedHandler = this.fileChangedHandler.bind(this);
  }

  state = {
    showAction: false,
    currentField: '',
    showInstructionModal: false,
    showSelfieModal: false,
    showCivilIdModal: false,
    showPassportModal: false,
    isClicked: this.props.tobeEmailed === 'tobeEmailed',
  };

  componentDidMount() {
    const {
      // intl, onUpdateSteps,
      onUpdateCurrentStep, isAllStepsCompleted, history,
    } = this.props;

    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      // onUpdateSteps(intl);
      onUpdateCurrentStep('step2');
    }

    // Show the instruction popup
    // setTimeout(() => {
    //   this.setState({ showInstructionModal: true });
    // }, 500);
  }

  handleCancelAction = () => {
    this.setState({
      showAction: false,
    });
  }

  handleShowAction = ({ currentTarget }) => {
    this.setState({
      showAction: true,
      currentField: currentTarget.name,
    });
  }

  handleGoToTakePhoto = () => {
    const { history } = this.props;
    const { currentField } = this.state;
    history.push({
      pathname: PATH.TAKE_PHOTO,
      state: { currentField },
    });
  }

  handleUploadPhoto = (file) => {
    const { onUpdateIdPassport } = this.props;
    const { currentField } = this.state;
    // console.log('currentField, file', currentField, file);
    onUpdateIdPassport(currentField, file.base64);
    this.setState({ showAction: false });
  }

  /** Image file handler (Resize image + base64 type */
  fileChangedHandler = (event) => {
    const { onUpdateIdPassport } = this.props;
    const { currentField } = this.state;

    let fileInput = false;
    if (event.target.files[0]) {
      fileInput = true;
    }
    if (fileInput) {
      Resizer.imageFileResizer(
        event.target.files[0],
        800,
        480,
        'JPEG',
        70,
        0,
        (uri) => {
          // console.log('image ', uri);
          onUpdateIdPassport(currentField, uri);
          this.setState({ showAction: false });
        },
        'base64',
      );
    }
  }

  /** only for to be emailed checkbox */
  onElementChange = (event) => {
    // event.preventDefault();
    const { onUpdateIdPassport } = this.props;
    const { target: { name, value } } = event;


    this.setState(prevState => ({ isClicked: !prevState.isClicked }), () => {
      const { isClicked } = this.state;
      if (isClicked) {
        onUpdateIdPassport(name, value);
      } else {
        onUpdateIdPassport(name, '');
      }
    });
    // if (tobeEmailed === '') onUpdateIdPassport(name, value);
  }

  onHandleInfoClick = () => {
    this.setState({ showInstructionModal: true });
  }

  render() {
    const {
      history, selfie, civilIdFront, civilIdBack, passport, onUpdateCurrentStep, onSaveApplicant, onUpdateHistory, intl,
      onUpdateSteps, isClientIdsCompleted, tobeEmailed,
    } = this.props;
    const { showAction } = this.state;
    const { ID_PASSPORT } = FORM_KEYS;

    const isComingFromPreview = !!(history && history.location.state && history.location.state.fromPreview);

    const footer = (
      <FooterAction
        isSingleButton={isComingFromPreview || isClientIdsCompleted || tobeEmailed !== ''}
        leftButton={!isComingFromPreview && (tobeEmailed === '' || tobeEmailed === null) && 'skipForNow'}
        onLeftButtonClick={() => history.push(PATH.PERSONAL_INFORMATION)}
        rightButton="continue"
        onRightButtonClick={() => {
          onUpdateCurrentStep('step3');
          onSaveApplicant(false);
          onUpdateSteps(intl);
          onUpdateHistory(APPLICANT_HISTORY_CODE.SUBMIT_SCANNING.code, APPLICANT_HISTORY_CODE.SUBMIT_SCANNING.codeI18n);
          if (isComingFromPreview) {
            history.push(PATH.FORM_AGREEMENTS);
          } else {
            history.push(PATH.PERSONAL_INFORMATION);
          }
        }}
        isDisabled={(!isClientIdsCompleted && tobeEmailed === '')}
        isTranslate
      />
    );
    return (
      <>
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container">
            <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
              <FormElementContainer>
                <Label isTranslate label="step.idPassport.enterCivilIdPlaceholder" withInfo onWithInfoClick={() => this.onHandleInfoClick()} />
                <UploadButton name={ID_PASSPORT.SELFIE} img={selfie} onClick={this.handleShowAction} />
              </FormElementContainer>
              <Button
                className="scanning__link"
                type="button"
                value={intl.formatMessage({ id: 'step.idPassport.upload.seeSample' })}
                isLink
                isSmall
                onButtonClick={() => this.setState({ showSelfieModal: true })}
              />

              <FormElementContainer>
                <Label isTranslate label="step.idPassport.upload.civilId" withInfo onWithInfoClick={() => this.onHandleInfoClick()} />
                <FormElementContainer isMultpleElements>
                  <UploadButton name={ID_PASSPORT.CIVIL_ID_FRONT} label="step.idPassport.upload.front" img={civilIdFront} onClick={this.handleShowAction} />
                  <UploadButton name={ID_PASSPORT.CIVIL_ID_BACK} label="step.idPassport.upload.back" img={civilIdBack} onClick={this.handleShowAction} />
                </FormElementContainer>
              </FormElementContainer>
              <Button
                className="scanning__link"
                type="button"
                value={intl.formatMessage({ id: 'step.idPassport.upload.seeSample' })}
                isLink
                isSmall
                onButtonClick={() => this.setState({ showCivilIdModal: true })}
              />

              <FormElementContainer>
                <Label isTranslate label="step.idPassport.upload.passportLabel" withInfo onWithInfoClick={() => this.onHandleInfoClick()} />
                <UploadButton name={ID_PASSPORT.PASSPORT} label="step.idPassport.upload.passport" img={passport} onClick={this.handleShowAction} />
              </FormElementContainer>
              <Button
                className="scanning__link"
                type="button"
                value={intl.formatMessage({ id: 'step.idPassport.upload.seeSample' })}
                isLink
                isSmall
                onButtonClick={() => this.setState({ showPassportModal: true })}
              />
            </PaddedContainer>

            {(isComingFromPreview || tobeEmailed === 'tobeEmailed') && (
              <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
                <CheckMark
                  type="checkbox"
                  label={intl.formatMessage({ id: 'scanning.tobeEmailed' }, { email: process.env.REACT_APP_MARKAZ_EMAIL })}
                  id="tobeEmailed"
                  name={ID_PASSPORT.TO_BE_EMAILED}
                  defaultValue={tobeEmailed}
                // hasContainer
                  onCheckMarkChange={this.onElementChange}
                />
              </PaddedContainer>
            )}

          </div>
          {!isMobileOnly && footer}

          <ActionModal visible={showAction} onCancel={this.handleCancelAction}>
            <div className="uploadButton">
              <label htmlFor="uploader">
                <input type="file" id="uploader" onChange={this.fileChangedHandler} />
                <FormattedMessage id="addAPhoto" />
              </label>
            </div>
            {/* <Button value="Take Photo" isLink onButtonClick={this.handleGoToTakePhoto} />
          {currentField !== ID_PASSPORT.SELFIE && (
            <>
              <div className="uploadButton">
                <input type="file" id="uploader" onChange={e => this.fileChangedHandler(e)} />
                <label htmlFor="uploader">Browse</label>
              </div>
            </>
          )} */}
          </ActionModal>
          <Modal
            title={intl.formatMessage({ id: 'step.idPassport.instruction.title' })}
            showModal={this.state.showInstructionModal}
            onClose={() => this.setState({ showInstructionModal: false })}
            customClassName="scanning__modal"
            withPadding
          >
            <table>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: 'top' }}>
                    <p>1. </p>
                  </td>
                  <td>
                    <p>{intl.formatMessage({ id: 'step.idPassport.instruction.p1' })}</p>
                    <p>
                      {intl.formatMessage({ id: 'step.idPassport.instruction.p1.a' })}
                      <br />
                      {intl.formatMessage({ id: 'step.idPassport.instruction.p1.b' })}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'top' }}>
                    <p>2. </p>
                  </td>
                  <td>
                    <p>{intl.formatMessage({ id: 'step.idPassport.instruction.p2' })}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'top' }}>
                    <p>3. </p>
                  </td>
                  <td>
                    <p>{intl.formatMessage({ id: 'step.idPassport.instruction.p3' })}</p>
                    <p>
                      {intl.formatMessage({ id: 'step.idPassport.instruction.p3.a' })}
                      <br />
                      {intl.formatMessage({ id: 'step.idPassport.instruction.p3.b' })}
                      <br />
                      {intl.formatMessage({ id: 'step.idPassport.instruction.p3.c' })}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'top' }}>
                    <p>4. </p>
                  </td>
                  <td>
                    <p>{intl.formatMessage({ id: 'step.idPassport.instruction.p4' })}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal>
          <Modal
            title={intl.formatMessage({ id: 'step.idPassport.upload.sample.selfie' })}
            showModal={this.state.showSelfieModal}
            onClose={() => this.setState({ showSelfieModal: false })}
            customClassName="scanning__photo"
            withPadding
          >
            <img src="images/selfie-photo.png" alt="sample selfie" />
          </Modal>
          <Modal
            title={intl.formatMessage({ id: 'step.idPassport.upload.sample.civilId' })}
            showModal={this.state.showCivilIdModal}
            onClose={() => this.setState({ showCivilIdModal: false })}
            customClassName="scanning__photo"
            withPadding
          >
            <img src="images/civil-id.png" alt="sample civil id" />
          </Modal>
          <Modal
            title={intl.formatMessage({ id: 'step.idPassport.upload.sample.passport' })}
            showModal={this.state.showPassportModal}
            onClose={() => this.setState({ showPassportModal: false })}
            customClassName="scanning__photo"
            withPadding
          >
            <img src="images/passport.png" alt="sample passport" />
          </Modal>
        </PageContentWrapper>
        {isMobileOnly && footer}
      </>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  selfie: selectors.getSelfie(state),
  civilIdFront: selectors.getCivilIdFront(state),
  civilIdBack: selectors.getCivilIdBack(state),
  passport: selectors.getPassport(state),
  tobeEmailed: selectors.getIsTobeEmailed(state),
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  isClientIdsCompleted: selectors.isIdsUploaded(state),
});

const mapDispatchToProps = dispatch => ({
  onSaveApplicant: isGenerate => dispatch(applicantAction.updateApplicant(isGenerate)),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onUpdateIdPassport: (name, value) => dispatch(idPassportAction.updateIdPassportData(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Scanning)));
